import { Outlet } from 'react-router-dom';
import Header from "../navigation/header";

function LearnerLayout() {


    return (
        <>
            <Header />

            <main>
                <Outlet /> {/* where current page gets rendered */}

            </main>


        </>

    )
}

export default LearnerLayout;